import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import type { IPlace } from "@bbj-types/address";
import { AutocompletePlaces } from "@inputs/autocomplete/AutocompletePlacesUniq";
import { Chip, TextField, autocompleteClasses } from "@mui/material";
import { type FieldValues, type Path, type PathValue, useController } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export type TPerimeterOption = { id: string; label: string };

const toOption = (place: IPlace): TPerimeterOption => ({ id: place._id, label: place.placeLabel });
const toPlace = (option: TPerimeterOption): IPlace => ({ _id: option.id, placeLabel: option.label, placeKind: "" });

export const FormGenInputPerimeter = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
}: IFormGenInputProps<Schema, T>) => {
  const { field, fieldState } = useController({
    control,
    name: uiSchemaElement.scope as unknown as Path<T>,
    defaultValue: [] as PathValue<T, Path<T>>,
  });

  return (
    <AutocompletePlaces
      multiple
      value={field.value.map(toPlace)}
      onChange={(_, places) => field.onChange(places.map(toOption))}
      onBlur={field.onBlur}
      fullWidth
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          label={uiSchemaElement.label}
          size="small"
          error={Boolean(fieldState.error)}
          helperText={fieldState.error?.message}
        />
      )}
      renderValue={(places, getTagProps) =>
        places.map((place, index) => (
          <Chip
            color="yellow"
            label={place.placeLabel}
            size="small"
            sx={{ [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } }}
            {...getTagProps({ index })}
            key={place._id}
          />
        ))
      }
      limitTags={3}
    />
  );
};
